module.exports = __webpack_public_path__ + "static/media/HTML5.092bdf3e.svg";